const initBanner = () => {
    $(".banner-main-with-thumbnail .banner-slide").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: false,
        autoplaySpeed: 5000,

    })

    $(".banner-main-with-thumbnail .thumbnail-slide").slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        autoplay: true,
        arrows: false,
        autoplaySpeed: 5000,

    })

}

module.exports = initBanner;